// @flow
import NotAssignedList from './NotAssignedList';

export default NotAssignedList;
